import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { PDFDocument, rgb } from "pdf-lib";
import download from 'downloadjs';
import Button from 'components/form/Button';
import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import ShareButton from 'components/Layout/ShareButton';
import {
  downloadCustomCertificate,
  fetchCertificate,
  setIsPremiumPopup,
  throwSuccess,
} from 'store/slices';
import {
  bytesToBase64,
  checkEmailVerification,
  combineArrayS3,
  downloadFile,
  generatePreSignedUrl,
  getCertificateData,
  getCertificatePdf,
  getDataFromLocalStorage,
  objectToFormData,
  titleCaseString,
  // hexToRgbA,
  urlToUnitArray,
  VERIFICATION_STEPS,
} from 'utils/helpers';
import OldCertificate from 'components/Layout/OldCertificate';
import { certificatePath, icons, newUserCertificate } from 'utils/constants';
import { Image } from 'react-bootstrap';
import CertificatePreview from './CertificatePreview';
import MembershipCertificate from 'components/Layout/MembershipCertificate';
import MembershipCard from 'components/Layout/MembershipCard';
import axios from 'axios';
import { saveAs } from 'file-saver';
import CertificateCard from './CertificateCard/CertificateCard';
import { useNavigate } from 'react-router-dom';

const CertificatesAndRewards = () => {
  const dispatch = useDispatch();
  const { comitteeMemberCategoryList } = useSelector((state) => ({
    comitteeMemberCategoryList: state.global.comitteeMemberCategoryList,
  }));

  const [isLoading, setIsLoading] = useState(true);
  const [pageData, setPageData] = useState([]);
  const [loadingIndexes, setLoadingIndexes] = useState([]);
  const [loadingButtons, setLoadingButtons] = useState([]);
  const navigate = useNavigate();

  // const handleDownload = async (data) => {

  //   let certificateData = getCertificateData(data?.filed_data, {
  //     certificate_number: data?.certificate_number || '',
  //     paper_title: data?.paper_title || '',
  //     create_at: data?.create_at || '',
  //   });
  //   const pdfFileData = await urlToUnitArray(data.s3File);
  //   const pdfBytes = await getCertificatePdf(pdfFileData, certificateData);
  //   download(pdfBytes, data.img, 'application/pdf');
  // };

  // const generatePreviewURL = async (data) => {
  //   let certificateData = getCertificateData(data?.filed_data, {
  //     certificate_number: data?.certificate_number || '',
  //     paper_title: data?.paper_title || '',
  //     create_at: data?.create_at || '',
  //   });
  //   const pdfFileData = await urlToUnitArray(data.s3File);
  //   const pdfBytes = await getCertificatePdf(pdfFileData, certificateData);
  //   const url = bytesToBase64(pdfBytes);
  //   const previewUrl = `data:application/pdf;base64,${url}`;
  //   return previewUrl;
  // };

  const generatePreviewURL = async (data) => {
  const fileUrl = data?.s3File;
  const extension = fileUrl?.split('.').pop()?.toLowerCase();

  if (extension !== 'pdf') {
    return fileUrl; // just return image url
  }

  let certificateData = getCertificateData(data?.filed_data, {
    certificate_number: data?.certificate_number || '',
    paper_title: data?.paper_title || '',
    create_at: data?.create_at || '',
  });

  try {
    const pdfFileData = await urlToUnitArray(fileUrl);
    const pdfBytes = await getCertificatePdf(pdfFileData, certificateData);
    const url = bytesToBase64(pdfBytes);
    return `data:application/pdf;base64,${url}`;
  } catch (err) {
    console.error("PDF parse failed:", err);
    return null;
  }
};



  const getProfiles = async () => {
    const response = await dispatch(fetchCertificate());
    const newData = response?.data?.map((o) => {
      return { ...o, img: o?.img || o?.certificate };
    });

    let list = await combineArrayS3(newData || [], 'img', certificatePath);

    const updatedList = await Promise.all(
      list?.map(async (item, index) => {
        const urlType = item?.img?.split('.').pop();

        if (urlType === 'pdf') {
          setLoadingIndexes((prevIndexes) => [...prevIndexes, index]);
          const previewUrl = await generatePreviewURL(item);
          setLoadingIndexes((prevIndexes) =>
            prevIndexes?.filter((i) => i !== index)
          );
          return { ...item, previewUrl };
        } else {
          return item;
        }
      })
    );

    setPageData(updatedList);
    setIsLoading(false);
  };

  useEffect(() => {
    getProfiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const userData = getDataFromLocalStorage();

  const { user_type: userType, membership_details } = userData;
  const { id: membershipID } = membership_details || {};

  const access = {
    isShare: userType === '3',
    isUpgradeButton: membershipID === 2 || membershipID === 11,
    isCertificate: ![2, 11].includes(membershipID),
  };

  const sendToParent = (searchValue) => {
    if (searchValue) {
      const lowerCaseSearchValue = searchValue.toLowerCase();
      let data = [];
      pageData?.filter((elem) => {
        const lowerCaseTitle = elem?.title?.toLowerCase();
        const lowerCaseCertificateId = elem?.certificate_number?.toLowerCase();
        if (lowerCaseTitle && lowerCaseTitle.includes(lowerCaseSearchValue)) {
          data.push(elem);
        } else {
          if (
            lowerCaseCertificateId &&
            lowerCaseCertificateId.includes(lowerCaseSearchValue)
          ) {
            data.push(elem);
          }
        }
        return elem;
      });
      setPageData(data);
    } else {
      getProfiles();
    }
  };

  return (
    <Card className="cps-40 cpe-40 cpt-42 cpb-42">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div className="text-24-500 color-title-navy font-poppins text-center">
          Certificates & Rewards
        </div>
        <div className="d-flex gap-3">
          {access?.isCertificate ? (
            <div className="">
              <MembershipCertificate />
            </div>
          ) : (
            <div
              className=""
              id="membership-certificate-container"
              onClick={() => {
               if (!checkEmailVerification(dispatch,navigate,VERIFICATION_STEPS.PROFILE_ONLY)) return;
                dispatch(setIsPremiumPopup(true));
              }}
            >
              <div>
                <img
                  src={icons.primaryMemberCertificate}
                  alt="cer"
                  className="me-3"
                />
              </div>
              <div className="text-16-500 color-new-car text-center">
                <div>Upgrade To Premium</div>
                <div>For The Membership Certificate</div>
              </div>
            </div>
          )}
          <div className="">
            <MembershipCard />
          </div>
        </div>
      </div>
      <div className="mt-5">
        <OldCertificate
          sendToParent={sendToParent}
          handleSuccess={() => {
            getProfiles();
          }}
        />
      </div>
      {isLoading ? (
        <div className="d-flex align-items-center justify-content-center cpt-50 cpb-50">
          <Loader size="md" />
        </div>
      ) : pageData?.length === 0 ? (
        <div className="d-flex justify-content-center text-15-400 cpb-50 cpt-50 cmt-50 border">
          No Data Found
        </div>
      ) : (
        <div className="cmt-40 fadeInUp">
          {/* Certificate New Code */}
          <div className="row">
            {pageData?.map((elem, index) => {
              const ocmCategory = comitteeMemberCategoryList?.find(
                (o) => o.id === +elem?.user_type_category
              )?.name;
              return (
                <div
                  className="col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
                  key={index}
                >
                  <CertificateCard
                    ocmCategory={ocmCategory}
                    access={access}
                    elem={elem}
                    index={index}
                    loadingIndexes={loadingIndexes}
                    getProfiles={getProfiles}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </Card>
  );
};
export default CertificatesAndRewards;

//Certificate Old Code

//  {pageData?.map((elem, index) => {
//             const {
//               title,
//               img,
//               user_type,
//               certificate_number,
//               isAwardWinner,
//               event_name,
//               event_type,
//               filed_data,
//               event_id,
//               certificate_id,
//               abstract_id,
//             } = elem;
//             const urlType = img?.split('.').pop();
//             const ocmCategory = comitteeMemberCategoryList?.find(
//               (o) => o.id === +elem?.user_type_category
//             )?.name;
//             const isEmptyFieldData = filed_data === '';
//             return (
//               <>
//                 <div
//                   className="row border cps-18 cpt-18 cpb-18 mb-3"
//                   key={index}
//                 >
//                   <CertificatePreview
//                     access={access}
//                     elem={elem}
//                     index={index}
//                     loadingIndexes={loadingIndexes}
//                   />
//                   {/* <div className="col-md-3">
//                     {loadingIndexes.includes(index) ? (
//                       <div className="d-flex justify-content-center align-items-center h-100">
//                         <Loader />
//                       </div>
//                     ) : access?.isUpgradeButton ? (
//                       <img
//                         src={icons.membershipCertificate}
//                         alt="cer"
//                         className="fit-image fill"
//                       />
//                     ) : ["pdf"].includes(urlType) ? (
//                       <iframe
//                         src={previewUrl}
//                         title="certificate"
//                         style={{
//                           height: "100%",
//                           width: "100%",
//                         }}
//                       />
//                     ) : (
//                       <Profile url={s3File} size="s-136" />
//                     )}
//                   </div> */}
//                   <div className="col-md-9">
//                     <div className="d-flex flex-column justify-content-between h-100 ms-3 mb-3">
//                       <div className="text-16-500 color-subtitle-navy">
//                         {title ? title : titleCaseString(event_name)}
//                       </div>
//                       {/* {event_name && (
//                         <div className="text-16-500 color-subtitle-navy mt-2">
//                           {titleCaseString(event_name)}
//                         </div>
//                       )} */}
//                       {ocmCategory && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           {ocmCategory}
//                         </div>
//                       )}
//                       {user_type === '1' && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           Participation
//                         </div>
//                       )}
//                       {user_type === '3' && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           Keynote Speakers
//                         </div>
//                       )}
//                       {user_type === '5' && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           Session Speakers
//                         </div>
//                       )}
//                       {user_type === '4' && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           Research Paper Presentation
//                         </div>
//                       )}
//                       {certificate_number && (
//                         <div className="mt-2">
//                           <span className="text-12-400 color-black-olive">
//                             Certificate No:
//                           </span>
//                           <span className="text-12-400 color-title-navy ms-1">
//                             {certificate_number}
//                           </span>
//                         </div>
//                       )}
//                       {isAwardWinner && (
//                         <div className="text-12-400 color-title-navy">
//                           Award winner
//                         </div>
//                       )}

//                       <div className="d-flex align-items-end flex-grow-1">
//                         <Button
//                           isRounded
//                           text={
//                             access.isUpgradeButton && event_type === 2
//                               ? 'Upgrade to Download Certificate'
//                               : 'Download Certificate'
//                           }
//                           btnStyle="primary-dark"
//                           icon={
//                             access.isUpgradeButton &&
//                             event_type === 2 && (
//                               <Image
//                                 src={icons.primaryCrown}
//                                 className="me-2 white-crown"
//                                 height={20}
//                                 width={21}
//                               />
//                             )
//                           }
//                           btnLoading={loadingButtons.includes(index)}
//                           disabled={loadingButtons.includes(index)}
//                           className="cps-10 cpe-10 h-35 text-nowrap me-2"
//                           onClick={async () => {
//                             setLoadingButtons((prev) => [...prev, index]);
//                             try {
//                               if (access?.isUpgradeButton && event_type === 2) {
//                                 dispatch(setIsPremiumPopup(true));
//                               } else if (urlType === 'pdf') {
//                                 if (isEmptyFieldData) {
//                                   const payload = {
//                                     event_id,
//                                     id: certificate_id,
//                                     user_id: userData?.id,
//                                     abstract_id,
//                                   };
//                                   await downloadMyNewCertificate(payload);
//                                 } else {
//                                   await handleDownload(elem);
//                                 }
//                               } else {
//                                 await dispatch(downloadFile(elem.img));
//                               }
//                             } catch (error) {
//                               console.error(
//                                 'Error downloading certificate:',
//                                 error
//                               );
//                             }

//                             setLoadingButtons((prev) =>
//                               prev.filter((btnIndex) => btnIndex !== index)
//                             );
//                           }}
//                         />
//                         {access.isShare && <ShareButton />}
//                       </div>
//                     </div>
//                   </div>
//                   {/* <div style={{ width: "175px", height: "124px" }}>
//                   {["pdf"].includes(urlType) ? (
//                     <iframe
//                       src={elem?.s3File}
//                       title="certificate"
//                       style={{
//                         height: "100%",
//                         width: "100%",
//                       }}
//                     />
//                   ) : (
//                     <img src={s3File} alt="cer" className="fit-image fill" />
//                   )}
//                 </div>

//                 <div className="d-flex flex-column justify-content-between flex-grow-1 ms-3">
//                   <div className="text-16-500 color-subtitle-navy">{title}</div>
//                   <div className="d-flex align-items-center gap-5">
//                     <Button
//                       isRounded
//                       text="Download Certificate"
//                       btnStyle="primary-dark"
//                       className="cps-10 cpe-10 h-35 text-nowrap"
//                       onClick={() => {
//                         dispatch(downloadFile(elem.img));
//                       }}
//                     />
//                     {access.isShare && <ShareButton />}
//                   </div>
//                 </div> */}
//                 </div>
//               </>
//             );
//           })}

// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// // import { PDFDocument, rgb } from "pdf-lib";
// import download from 'downloadjs';
// import Button from 'components/form/Button';
// import Card from 'components/Layout/Card';
// import Loader from 'components/Layout/Loader';
// import ShareButton from 'components/Layout/ShareButton';
// import {
//   downloadCustomCertificate,
//   fetchCertificate,
//   setIsPremiumPopup,
//   throwError,
//   throwSuccess,
// } from 'store/slices';
// import {
//   bytesToBase64,
//   combineArrayS3,
//   downloadFile,
//   generatePreSignedUrl,
//   getCertificateData,
//   getCertificatePdf,
//   getDataFromLocalStorage,
//   objectToFormData,
//   titleCaseString,
//   // hexToRgbA,
//   urlToUnitArray,
// } from 'utils/helpers';
// import OldCertificate from 'components/Layout/OldCertificate';
// import {
//   certificateBackgroundPath,
//   certificatePath,
//   icons,
//   newUserCertificate,
// } from 'utils/constants';
// import { Image } from 'react-bootstrap';
// import CertificatePreview from './CertificatePreview';
// import MembershipCertificate from 'components/Layout/MembershipCertificate';
// import MembershipCard from 'components/Layout/MembershipCard';
// import axios from 'axios';
// import { saveAs } from 'file-saver';
// import html2pdf from 'html2pdf.js';

// const CertificatesAndRewards = () => {
//   const dispatch = useDispatch();
//   const { comitteeMemberCategoryList } = useSelector((state) => ({
//     comitteeMemberCategoryList: state.global.comitteeMemberCategoryList,
//   }));

//   const [isLoading, setIsLoading] = useState(true);
//   const [pageData, setPageData] = useState([]);
//   const [loadingIndexes, setLoadingIndexes] = useState([]);
//   const [loadingButtons, setLoadingButtons] = useState([]);

//   const handleDownload = async (data) => {
//     let certificateData = getCertificateData(data?.filed_data, {
//       certificate_number: data?.certificate_number || '',
//       paper_title: data?.paper_title || '',
//       create_at: data?.create_at || '',
//     });
//     const pdfFileData = await urlToUnitArray(data.s3File);
//     const pdfBytes = await getCertificatePdf(pdfFileData, certificateData);
//     download(pdfBytes, data.img, 'application/pdf');
//   };

//   const generatePreviewURL = async (data) => {
//     let certificateData = getCertificateData(data?.filed_data, {
//       certificate_number: data?.certificate_number || '',
//       paper_title: data?.paper_title || '',
//       create_at: data?.create_at || '',
//     });
//     const pdfFileData = await urlToUnitArray(data.s3File);
//     const pdfBytes = await getCertificatePdf(pdfFileData, certificateData);
//     const url = bytesToBase64(pdfBytes);
//     const previewUrl = `data:application/pdf;base64,${url}`;
//     return previewUrl;
//   };
//   const getProfiles = async () => {
//     const response = await dispatch(fetchCertificate());
//     const newData = response?.data?.map((o) => {
//       return { ...o, img: o?.img || o?.certificate };
//     });

//     let list = await combineArrayS3(newData || [], 'img', certificatePath);

//     const updatedList = await Promise.all(
//       list?.map(async (item, index) => {
//         const urlType = item?.img?.split('.').pop();

//         if (urlType === 'pdf') {
//           setLoadingIndexes((prevIndexes) => [...prevIndexes, index]);
//           const previewUrl = await generatePreviewURL(item);
//           setLoadingIndexes((prevIndexes) =>
//             prevIndexes?.filter((i) => i !== index)
//           );
//           // return { ...item, previewUrl };
//           return { ...item };
//         } else {
//           return item;
//         }
//       })
//     );

//     setPageData(updatedList);
//     setIsLoading(false);
//   };

//   const convertToBase64 = async (imageUrl) => {
//     const response = await fetch(imageUrl);
//     const blob = await response.blob();
//     return new Promise((resolve) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(blob);
//       reader.onloadend = () => resolve(reader.result);
//     });
//   };
//   const generateHtml = (values, HTML) => {
//     let updatedHtml = HTML || '';
//     if (updatedHtml) {
//       Object.keys(values)?.forEach((key) => {
//         const placeholder = `{{${key}}}`;
//         updatedHtml = updatedHtml?.replaceAll(placeholder, values[key] || '');
//       });
//     }
//     return updatedHtml;
//   };

//   const handleDownloadPdf = async (htmlContent) => {
//     if (!htmlContent) return;
//     try {
//       const container = document.createElement('div');
//       container.innerHTML = htmlContent;

//       const options = {
//         margin: 10,
//         filename: 'certificate.pdf',
//         html2canvas: {
//           scale: 2,
//           useCORS: true,
//           logging: false,
//           letterRendering: true,
//         },
//         jsPDF: {
//           unit: 'mm',
//           format: 'a4',
//           orientation: 'landscape',
//         },
//       };

//       await html2pdf()
//         .set(options)
//         .from(container)
//         .save()
//         .then(() => {
//           dispatch(throwSuccess('Downloaded successfully!'));
//         })
//         .catch((err) => {
//           dispatch(throwError({ message: err }));
//         });
//     } catch (error) {
//       dispatch(throwError({ message: error }));
//     }
//   };

//   const handelDwonloadHTML = async (Certificate) => {
//     const response = await generatePreSignedUrl(
//       Certificate?.background_file,
//       certificateBackgroundPath
//     );

//     if (response) {
//       const base64Image = await convertToBase64(response);

//       const htmlStr = generateHtml(
//         {
//           conference_bg_img: base64Image,
//         },
//         Certificate.certificate_html
//       );
//       if (htmlStr) {
//         handleDownloadPdf(htmlStr);
//       }
//     }
//   };

//   const downloadMyNewCertificate = async (data) => {
//     const response = await dispatch(
//       downloadCustomCertificate(objectToFormData(data))
//     );
//     if (response?.status === 200) {
//       let s3URL = '';
//       const certificateUrl = response?.data;
//       s3URL = await generatePreSignedUrl(certificateUrl, newUserCertificate);
//       const responseCer = await axios.get(s3URL, {
//         responseType: 'blob',
//       });
//       const blob = new Blob([responseCer?.data], {
//         type: responseCer?.data?.type,
//       });
//       saveAs(blob, 'certificate.pdf');
//       dispatch(throwSuccess(response?.message));
//     }
//   };

//   useEffect(() => {
//     getProfiles();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);
//   const userData = getDataFromLocalStorage();

//   const { user_type: userType, membership_details } = userData;
//   const { id: membershipID } = membership_details || {};

//   const access = {
//     isShare: userType === '3',
//     isUpgradeButton: membershipID === 2 || membershipID === 11,
//     isCertificate: ![2, 11].includes(membershipID),
//   };

//   const sendToParent = (searchValue) => {
//     if (searchValue) {
//       const lowerCaseSearchValue = searchValue.toLowerCase();
//       let data = [];
//       pageData?.filter((elem) => {
//         const lowerCaseTitle = elem?.title?.toLowerCase();
//         const lowerCaseCertificateId = elem?.certificate_number?.toLowerCase();
//         if (lowerCaseTitle && lowerCaseTitle.includes(lowerCaseSearchValue)) {
//           data.push(elem);
//         } else {
//           if (
//             lowerCaseCertificateId &&
//             lowerCaseCertificateId.includes(lowerCaseSearchValue)
//           ) {
//             data.push(elem);
//           }
//         }
//         return elem;
//       });
//       setPageData(data);
//     } else {
//       getProfiles();
//     }
//   };

//   return (
//     <Card className="cps-40 cpe-40 cpt-42 cpb-42">
//       <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
//         <div className="text-24-500 color-title-navy font-poppins text-center">
//           Certificates & Rewards
//         </div>
//         <div className="d-flex gap-3">
//           {access.isCertificate ? (
//             <div className="">
//               <MembershipCertificate />
//             </div>
//           ) : (
//             <div
//               className=""
//               id="membership-certificate-container"
//               onClick={() => {
//                 dispatch(setIsPremiumPopup(true));
//               }}
//             >
//               <div>
//                 <img
//                   src={icons.primaryMemberCertificate}
//                   alt="cer"
//                   className="me-3"
//                 />
//               </div>
//               <div className="text-16-500 color-new-car text-center">
//                 <div>Upgrade To Premium</div>
//                 <div>For The Membership Certificate</div>
//               </div>
//             </div>
//           )}
//           <div className="">
//             <MembershipCard />
//           </div>
//         </div>
//       </div>
//       <div className="mt-5">
//         <OldCertificate
//           sendToParent={sendToParent}
//           handleSuccess={() => {
//             getProfiles();
//           }}
//         />
//       </div>
//       {isLoading ? (
//         <div className="d-flex align-items-center justify-content-center cpt-50 cpb-50">
//           <Loader size="md" />
//         </div>
//       ) : pageData?.length === 0 ? (
//         <div className="d-flex justify-content-center text-15-400 cpb-50 cpt-50 cmt-50 border">
//           No Data Found
//         </div>
//       ) : (
//         <div className="cmt-40 fadeInUp">
//           {pageData?.map((elem, index) => {
//             const {
//               title,
//               img,
//               user_type,
//               certificate_number,
//               isAwardWinner,
//               event_name,
//               event_type,
//               filed_data,
//               event_id,
//               certificate_id,
//               abstract_id,
//             } = elem;
//             const urlType = img?.split('.').pop();
//             const ocmCategory = comitteeMemberCategoryList?.find(
//               (o) => o.id === +elem?.user_type_category
//             )?.name;
//             const isEmptyFieldData = filed_data === '';
//             return (
//               <>
//                 <div
//                   className="row border cps-18 cpt-18 cpb-18 mb-3"
//                   key={index}
//                 >
//                   <CertificatePreview
//                     access={access}
//                     elem={elem}
//                     index={index}
//                     loadingIndexes={loadingIndexes}
//                   />
//                   {/* <div className="col-md-3">
//                     {loadingIndexes.includes(index) ? (
//                       <div className="d-flex justify-content-center align-items-center h-100">
//                         <Loader />
//                       </div>
//                     ) : access?.isUpgradeButton ? (
//                       <img
//                         src={icons.membershipCertificate}
//                         alt="cer"
//                         className="fit-image fill"
//                       />
//                     ) : ["pdf"].includes(urlType) ? (
//                       <iframe
//                         src={previewUrl}
//                         title="certificate"
//                         style={{
//                           height: "100%",
//                           width: "100%",
//                         }}
//                       />
//                     ) : (
//                       <Profile url={s3File} size="s-136" />
//                     )}
//                   </div> */}
//                   <div className="col-md-9">
//                     <div className="d-flex flex-column justify-content-between h-100 ms-3 mb-3">
//                       <div className="text-16-500 color-subtitle-navy">
//                         {title ? title : titleCaseString(event_name)}
//                       </div>
//                       {/* {event_name && (
//                         <div className="text-16-500 color-subtitle-navy mt-2">
//                           {titleCaseString(event_name)}
//                         </div>
//                       )} */}
//                       {ocmCategory && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           {ocmCategory}
//                         </div>
//                       )}
//                       {user_type === '1' && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           Participation
//                         </div>
//                       )}
//                       {user_type === '3' && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           Keynote Speakers
//                         </div>
//                       )}
//                       {user_type === '5' && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           Session Speakers
//                         </div>
//                       )}
//                       {user_type === '4' && (
//                         <div className="text-14-400 color-black-olive mt-2">
//                           Research Paper Presentation
//                         </div>
//                       )}
//                       {certificate_number && (
//                         <div className="mt-2">
//                           <span className="text-12-400 color-black-olive">
//                             Certificate No:
//                           </span>
//                           <span className="text-12-400 color-title-navy ms-1">
//                             {certificate_number}
//                           </span>
//                         </div>
//                       )}
//                       {isAwardWinner && (
//                         <div className="text-12-400 color-title-navy">
//                           Award winner
//                         </div>
//                       )}

//                       <div className="d-flex align-items-end flex-grow-1">
//                         <Button
//                           isRounded
//                           text={
//                             access.isUpgradeButton && event_type === 2
//                               ? 'Upgrade to Download Certificate'
//                               : 'Download Certificate'
//                           }
//                           btnStyle="primary-dark"
//                           icon={
//                             access.isUpgradeButton &&
//                             event_type === 2 && (
//                               <Image
//                                 src={icons.primaryCrown}
//                                 className="me-2 white-crown"
//                                 height={20}
//                                 width={21}
//                               />
//                             )
//                           }
//                           btnLoading={loadingButtons.includes(index)}
//                           disabled={loadingButtons.includes(index)}
//                           className="cps-10 cpe-10 h-35 text-nowrap me-2"
//                           onClick={async () => {
//                             setLoadingButtons((prev) => [...prev, index]);
//                             try {
//                               if (elem?.certificate_html) {
//                                 console.log(elem);
//                                 await handelDwonloadHTML(elem);
//                               } else if (
//                                 access?.isUpgradeButton &&
//                                 event_type === 2
//                               ) {
//                                 dispatch(setIsPremiumPopup(true));
//                               } else if (urlType === 'pdf') {
//                                 if (isEmptyFieldData) {
//                                   const payload = {
//                                     event_id,
//                                     id: certificate_id,
//                                     user_id: userData?.id,
//                                     abstract_id,
//                                   };
//                                   await downloadMyNewCertificate(payload);
//                                 } else {
//                                   await handleDownload(elem);
//                                 }
//                               } else {
//                                 await dispatch(downloadFile(elem.img));
//                               }
//                             } catch (error) {
//                               console.error(
//                                 'Error downloading certificate:',
//                                 error
//                               );
//                             } finally {
//                               setLoadingButtons((prev) =>
//                                 prev.filter((btnIndex) => btnIndex !== index)
//                               );
//                             }
//                           }}
//                         />
//                         {access.isShare && <ShareButton />}
//                       </div>
//                     </div>
//                   </div>
//                   {/* <div style={{ width: "175px", height: "124px" }}>
//                   {["pdf"].includes(urlType) ? (
//                     <iframe
//                       src={elem?.s3File}
//                       title="certificate"
//                       style={{
//                         height: "100%",
//                         width: "100%",
//                       }}
//                     />
//                   ) : (
//                     <img src={s3File} alt="cer" className="fit-image fill" />
//                   )}
//                 </div>

//                 <div className="d-flex flex-column justify-content-between flex-grow-1 ms-3">
//                   <div className="text-16-500 color-subtitle-navy">{title}</div>
//                   <div className="d-flex align-items-center gap-5">
//                     <Button
//                       isRounded
//                       text="Download Certificate"
//                       btnStyle="primary-dark"
//                       className="cps-10 cpe-10 h-35 text-nowrap"
//                       onClick={() => {
//                         dispatch(downloadFile(elem.img));
//                       }}
//                     />
//                     {access.isShare && <ShareButton />}
//                   </div>
//                 </div> */}
//                 </div>
//               </>
//             );
//           })}
//         </div>
//       )}
//     </Card>
//   );
// };
// export default CertificatesAndRewards;
